/**
 * auth selectors
 */
import {
    createSelector,
    createSelectorCreator,
    defaultMemoize
} from 'reselect';
import isEqual from 'lodash.isequal';
import jwtDecode from 'jwt-decode';
import get from 'lodash.get';
import { isTokenExpired } from 'shared';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const selectAuth = state => state.auth;
const selectTimekeeper = state => state.timekeeper;

const idTokenSelector = createSelector(
    selectAuth,
    authState => authState
);

const selectProfile = createSelector(
    idTokenSelector,
    idTokenState => idTokenState && jwtDecode(idTokenState)
);

const selectIsAuthenticated = createSelector(
    [idTokenSelector, selectTimekeeper],
    (idTokenState, timekeeperState) =>
        !isTokenExpired(idTokenState, timekeeperState)
);

const makeSelectProfileValue = path =>
    createDeepEqualSelector(
        selectProfile,
        profileState => profileState && get(profileState, [].concat(path))
    );

export {
    selectAuth,
    idTokenSelector,
    selectProfile,
    makeSelectProfileValue,
    selectIsAuthenticated
};
